const clickstreamTrackerCore = (rawData, trackerEndpoint) => {
  const data = window.JSON.stringify(rawData)

  const ajax = new XMLHttpRequest()
  ajax.open('POST', trackerEndpoint, true)
  ajax.send(data)
}

export default clickstreamTrackerCore
